module.exports = __webpack_public_path__ + "static/media/font_bold.b4f3acfc.woff";